import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {forkJoin} from 'rxjs';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {ItemAtendimento} from '../../../modules/cadastro/models/lista-atendimento';
import {AtendimentoService} from '../../../modules/cadastro/services/atendimento.service';
import {FunilEtapa} from '../../../modules/cadastro/models/funil-etapa';

@Component({
  selector: 'app-kanbam',
  standalone: false,
  templateUrl: './kanbam.component.html',
  styleUrl: './kanbam.component.css'
})
export class KanbamComponent implements AfterViewInit {
  @ViewChild('scrollbarTop') scrollbarTop: ElementRef;
  @ViewChild('conteudoKanbam') conteudoKanbam: ElementRef;

  etapas: FunilEtapa[] = [];
  etapasEdicao: FunilEtapa[] = [];
  showModalAtendimento = false;
  showModalAlterarStatus = false;
  showModalNovoDocumento = false;
  showConfiguracao = false;
  statusSelecionado = '';
  statusDestino = 0;
  nomeStatusDestino = '';
  atendimentoSelecionadoId: number;

  constructor(
    private atendimentoService: AtendimentoService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.carregarFunil();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.sincronizarScroll(), 300);
  }

  carregarFunil(): void {
    this.atendimentoService.selecionarFunil().subscribe(response => {
      if (!response.sucesso) return;
      this.etapas = (response.dados as FunilEtapa[]).sort((a: FunilEtapa, b: FunilEtapa) => a.ordem - b.ordem);
      const consultas = this.etapas.map(etapa => this.atendimentoService.selecionarPorStatus(etapa.codigo));
      forkJoin(consultas).subscribe(resultados => {
        resultados.forEach((resultado, index) => {
          const itens = resultado.sucesso ? resultado.dados : [];
          this.etapas[index].atendimentos = this.distintos(itens);
          this.etapas[index].total = this.etapas[index].atendimentos
            .reduce((total, item) => total + Number(item.valor || 0), 0);
        });
        setTimeout(() => this.atualizarLarguraScroll(), 0);
      });
    });
  }

  abrirConfiguracao(): void {
    this.etapasEdicao = this.etapas.map(etapa => ({...etapa, atendimentos: []}));
    this.showConfiguracao = true;
  }

  adicionarEtapa(): void {
    const etapa = new FunilEtapa();
    etapa.nome = 'Nova coluna';
    etapa.ordem = this.etapasEdicao.length;
    this.etapasEdicao.push(etapa);
  }

  moverEtapa(index: number, deslocamento: number): void {
    const destino = index + deslocamento;
    if (destino < 0 || destino >= this.etapasEdicao.length) return;
    [this.etapasEdicao[index], this.etapasEdicao[destino]] =
      [this.etapasEdicao[destino], this.etapasEdicao[index]];
  }

  removerEtapa(index: number): void {
    this.etapasEdicao.splice(index, 1);
  }

  salvarConfiguracao(): void {
    if (!this.etapasEdicao.length || this.etapasEdicao.some(x => !x.nome.trim())) {
      this.toastr.error('Informe o nome de todas as colunas.');
      return;
    }
    this.atendimentoService.salvarFunil(this.etapasEdicao).subscribe(response => {
      if (response.sucesso) {
        this.toastr.success('Funil atualizado com sucesso.');
        this.showConfiguracao = false;
        this.carregarFunil();
      } else {
        this.toastr.error(response.errors?.[0]?.mensagem || 'Não foi possível atualizar o funil.');
      }
    });
  }

  abrirDetalhes(id: number): void {
    this.router.navigate(['cadastro/atendimento/detalhes/' + id]);
  }

  abrirModalNovoAtendimento(codigo: number): void {
    this.statusSelecionado = codigo.toString();
    this.showModalAtendimento = true;
  }

  abrirModalAlterarStatus(atendimentoId: number, indice: number): void {
    const proxima = this.etapas[indice + 1];
    if (!proxima) return;
    this.atendimentoSelecionadoId = atendimentoId;
    this.statusDestino = proxima.codigo;
    this.nomeStatusDestino = proxima.nome;
    this.showModalAlterarStatus = true;
  }

  abrirNovoDocumento(atendimentoId: number): void {
    this.atendimentoSelecionadoId = atendimentoId;
    this.showModalNovoDocumento = true;
  }

  fecharModal(): void {
    this.showModalAtendimento = false;
    this.carregarFunil();
  }

  fecharModalAlterarStatus(): void {
    this.showModalAlterarStatus = false;
    this.carregarFunil();
  }

  buscarIniciais(nome: string): string {
    return (nome || '').trim().split(' ').filter(Boolean).map(x => x[0].toUpperCase()).join('');
  }

  private distintos(items: ItemAtendimento[]): ItemAtendimento[] {
    return Array.from(new Map((items || []).map(item => [item.id, item])).values());
  }

  private sincronizarScroll(): void {
    if (!this.scrollbarTop || !this.conteudoKanbam) return;
    const topo = this.scrollbarTop.nativeElement;
    const conteudo = this.conteudoKanbam.nativeElement;
    topo.addEventListener('scroll', () => conteudo.scrollLeft = topo.scrollLeft);
    conteudo.addEventListener('scroll', () => topo.scrollLeft = conteudo.scrollLeft);
    this.atualizarLarguraScroll();
  }

  private atualizarLarguraScroll(): void {
    const barra = this.scrollbarTop?.nativeElement.querySelector('.scrollbar-content');
    if (barra && this.conteudoKanbam) barra.style.width = this.conteudoKanbam.nativeElement.scrollWidth + 'px';
  }
}
